<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul class="custom-font">
          <li>{{ routeName }}</li>
        </ul>
      </nav>
      <div class="copyright d-flex flex-wrap">
        <!-- &copy;by -->
        <a class="mr-2 mt-2 custom-font text-primary" href="https://muic.mahidol.ac.th/eng/">
          Mahidol University International College
        </a>
        <span class="mr-2 mt-2 custom-font"><i class="fa fa-phone-square" aria-hidden="true"></i>+66 (0) 2700 5000 <i class="fa fa-weixin" aria-hidden="true"></i>Line @MYMUIC :</span>
        <a class="mr-2" href="https://lin.ee/rMSY9VY"><img src="https://scdn.line-apps.com/n/line_add_friends/btn/en.png" alt="add" height="30" border="0"></a>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    computed: {
      routeName() {
        const { name } = this.$route;
        return this.capitalizeFirstLetter(name);
      }
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
    }
  };
</script>

<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Balsamiq+Sans&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Nunito:wght@600&display=swap');
  .custom-font{
    font-family: 'Nunito', sans-serif;
  }
  .font-en{ font-family: 'Rubik', sans-serif; }
</style>
